/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LootboxChanceContent } from './lootboxChanceContent';


export interface LootboxChance { 
    /**
     * The probability of a specific loot type dropping. Takes a value from 0 to 1
     */
    chance?: string;
    content?: LootboxChanceContent;
}

